import { useEffect, useState } from "react";
import { Download } from "lucide-react";

/**
 * Iter 91.12 — PWA update banner.
 * Listens for `lefteria-update-available` (dispatched by src/index.js when a
 * new service worker has installed and is waiting). Renders a slim top banner
 * with one tap "Ενημέρωση" that activates the pending SW and reloads.
 */
const UpdateBanner = () => {
  const [visible, setVisible] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    const onAvail = () => setVisible(true);
    window.addEventListener("lefteria-update-available", onAvail);
    // Also honour a pre-load event that fired before this component mounted.
    if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg && reg.waiting) setVisible(true);
      }).catch(() => {});
    }
    return () => window.removeEventListener("lefteria-update-available", onAvail);
  }, []);

  if (!visible) return null;

  const apply = () => {
    setApplying(true);
    try { if (typeof window.__lefteriaApplyUpdate === "function") window.__lefteriaApplyUpdate(); }
    catch { window.location.reload(); }
  };

  return (
    <div
      className="fixed top-0 inset-x-0 z-[80] bg-gradient-to-r from-[#F5A623] to-[#e29617] text-black text-xs font-semibold shadow-lg"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      data-testid="pwa-update-banner"
    >
      <div className="flex items-center justify-between gap-2 px-4 py-2">
        <div className="flex items-center gap-2 min-w-0">
          <Download size={14} className="flex-shrink-0" />
          <span className="truncate">Νεα Εκδοση Διαθεσιμη</span>
        </div>
        <button
          onClick={apply}
          disabled={applying}
          className="bg-black text-[#F5A623] text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full disabled:opacity-60"
          data-testid="pwa-update-apply"
        >
          {applying ? "..." : "Ενημερωση"}
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
